<header class="flex header p-2">
  <h2>{{ 'Reorganize_Process_Modal_Title' | translateWF: 'Reorganize Processes' }}</h2>
</header>

<section class="content">
  @if (isRouteCompleted) {
    <p-message severity="info" styleClass="mb-3">
      {{
        'Reorganize_Process_Modal_Route_Completed_Info'
          | translateWF: 'This route is already completed. You can add new processes to continue processing. All rolls will be verified to be in Finishing location.'
      }}
    </p-message>
  }

  @if (completedProcesses.length > 0) {
    <div class="processes-section">
      <h3 class="section-title">{{ 'Reorganize_Process_Modal_Completed_Processes' | translateWF: 'Completed Processes' }}</h3>
      <div class="completed-processes-list">
        @for (process of completedProcesses; track process.lineId) {
          <div class="process-item completed">
            {{ getProcessName(process) }}
          </div>
        }
      </div>
    </div>
  }

  @if (inProgressProcesses.length > 0) {
    <div class="processes-section">
      <h3 class="section-title">{{ 'Reorganize_Process_Modal_In_Progress_Processes' | translateWF: 'In Progress Processes' }}</h3>
      <div class="completed-processes-list">
        @for (process of inProgressProcesses; track process.lineId) {
          <div class="process-item in-progress">
            {{ getProcessName(process) }}
          </div>
        }
      </div>
    </div>
  }

  <div class="processes-section">
    <h3 class="section-title">{{ 'Reorganize_Process_Modal_Pending_Processes' | translateWF: 'Pending Processes' }}</h3>

    <div class="add-process-container">
      <label class="add-process-label">{{ 'Reorganize_Process_Modal_Add_Process' | translateWF: 'Add Process' }}</label>
      <p-select
        [(ngModel)]="selectedProcessToAdd"
        [options]="availableProcesses"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'Reorganize_Process_Modal_Select_A_Process' | translateWF: 'Select a process'"
        class="w-full"
        [showClear]="true"
        [filter]="true"
        (onChange)="onProcessSelected()"
      >
        <ng-template #filtericon>
          <i class="pi pi-search"></i>
        </ng-template>
      </p-select>
    </div>

    <p-orderlist
      [value]="pendingProcessesList"
      (onReorder)="onReorder()"
      [dragdrop]="true"
      [listStyle]="{ 'max-height': '400px' }"
      filterBy="name"
      [filterPlaceholder]="'Reorganize_Process_Modal_Search_Processes' | translateWF: 'Search processes'"
      [stripedRows]="true"
    >
      <ng-template let-process let-i="index" pTemplate="item">
        <div class="process-item-template">
          <span>{{ process.name }}</span>
          @if (isRollingAdmin || process.id !== '29') {
            <p-button
              icon="pi pi-trash"
              severity="danger"
              variant="text"
              [rounded]="true"
              size="small"
              (click)="onRemoveProcess(i)"
              [pTooltip]="'Reorganize_Process_Modal_Remove_Process' | translateWF: 'Remove process'"
            />
          }
        </div>
      </ng-template>
    </p-orderlist>
  </div>
</section>

<footer>
  <p-button [label]="'Reorganize_Process_Modal_Cancel' | translateWF: 'Cancel'" (click)="onClose()" />
  <p-button [label]="'Reorganize_Process_Modal_Save' | translateWF: 'Save'" (click)="onSave()" />
</footer>
